module.exports = __webpack_public_path__ + "img/10.220e56cb.png";